import { obterParametrosDaURL } from "../../../../functions";
import { TNotificacaoDoAplicativo } from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const ObterNotificacoesPorId = async (idMensagem: number): Promise<TNotificacaoDoAplicativo> => {

    const { token } = obterParametrosDaURL();

    try {

        const { data } = await api.get(`/NotificacaoPorId`, { params: { token, idMensagem } });

        return data;

    } catch (erro) {

        throw new ApiException(
            erro,
            'Erro ao buscar notificação do aplicativo'
        );
    }
}